var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"player-container"},[_c('div',{class:{visible: _vm.visible},attrs:{"id":"wowza_player"}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(!_vm.visible)?_c('div',{staticClass:"loader"}):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }